const personnel = [
  {
    name: "Malin Vernersson",
    photo: "/static/personnel/malin.webp",
    roleKey: "role.order",
    email: "Malin@toppowernordic.se",
    phone: {en: "+46-721 777 115", se: "0721-777 115"},
  },
  {
    name: "Bobbie Oskarsson",
    photo: "/static/personnel/bobbie.webp",
    roleKey: "role.keyAccountPartner",
    email: "Bobbie@toppowernordic.se",
    phone: {en: "+46-721 777 180", se: "0721-777 180"},
  },
  {
    name: "Emil Fremdling",
    photo: "/static/personnel/emil.webp",
    roleKey: "role.productManagerPartner",
    email: "Emil@toppowernordic.se",
    phone: {en: "+46-721 777 977", se: "0721-777 977"},
  },
  {
    name: "Marcus Hokkanen",
    photo: "/static/personnel/marcus.webp",
    roleKey: "role.accountManager",
    email: "Marcus@toppowernordic.se",
    phone: {en: "+46-736 563 994", se: "0736-563 994"},
  },
  {
    name: "Thomas Holmer",
    photo: "/static/personnel/thomas.webp",
    roleKey: "role.managingDirectorPartner",
    email: "Thomas@toppowernordic.se",
    phone: {en: "+46-704 943 653", se: "0704-943 653"},
  },
  {
    name: "Therese Thörne",
    photo: "/static/personnel/therese.webp",
    roleKey: "role.marketing",
    email: "Marketing@toppowernordic.se",
    phone: {en: "+46-171 44 23 00", se: "0171-44 23 00"},
  },
  {
    name: "Emre Bagci",
    photo: "/static/personnel/emre.webp",
    roleKey: "role.accountManager",
    email: "Emre@toppowernordic.se",
    phone: {en: "+46-700-177 797", se: "0700-177 797"},
  },
  {
    name: "Björn Leijon",
    photo: "/static/personnel/bjorn.webp",
    roleKey: "role.phoneOffice",
    email: "bjorn.l@toppowernordic.se",
    phone: {en: "+46-10-708 89 35", se: "010-708 89 35"},
  },
]

export default personnel
